/* eslint-disable @typescript-eslint/no-explicit-any */
import type { ReadWaitMusicApiResponse } from 'lib-shared-types-api';

import { transformWaitMusic } from './transformWaitMusic';

export function transformWaitMusicReadResponse(
  response: any,
): ReadWaitMusicApiResponse {
  response.data.wait_music.forEach((waitMusic) => {
    transformWaitMusic(waitMusic);
  });

  return response;
}
